<template>
  <v-container class="Profil">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-account-group</v-icon>{{$t('administration.profil.profil')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProfilForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </v-sheet>
</v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProfilForm from '../../components/profiluser/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ProfilUser';

const { mapFields } = createHelpers({
  getterType: 'profil/getField',
  mutationType: 'profil/updateField'
});

export default {
  name: 'ProfilCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ProfilForm
  },
  data() {
    return {
      item: {
        access : []
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('profil', ['create', 'reset'])
  }
};
</script>
